<template>
  <printBase ref="LinkQR035" :title="title" :id="id" :page="page" :width="800">
    <div class="printLinkQR" :slot="page == 1 ? 'content' : `content${page}`">
      <div class="printTitle">{{this.$store.state.storeInfo.name}}积分领用签收单</div>
      <table style="width: 100%" class="printContent" border="1" cellspacing="0" cellspadding="0">
        <thead>
          <td height="35" style="width: 10%;"><span>编号</span></td>
          <td height="35" style="width: 30%;"><span>姓名</span></td>
          <td height="35" style="width: 30%;"><span>联系方式</span></td>
          <td height="35" style="width: 30%;"><span>领用签字</span></td>
        </thead>
        <tr height="34" v-for="(item, pageIndex) in printInfoList" :key="pageIndex">
          <td style="width: 10%">{{pageIndex + 1}}</td>
          <td style="width: 30%">{{item.patientName}}</td>
          <td style="width: 30%">{{item.patientPhone}}</td>
          <td style="width: 30%"></td>
        </tr>
      </table>
    </div>
  </printBase>
</template>
<script>
import printBase from './printBase';
import utils from '../../libs/utils';
import points from '../../services/points';

export default {
  data() {
    return {
      title: 'Link-QR-035',
      id: 'LinkQR035',
      printInfo: {},
      printInfoList: [],
      page: 1,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(exchangeId) {
      points.pointApplyDetailList({ exchangeId }).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          res.data.data.list.forEach((item) => {
            item.patientPhone = `${item.patientPhone.slice(0, 3)}****${item.patientPhone.slice(-4)}`;
          });
          this.printInfoList = res.data.data.list;
          this.$nextTick(() => {
            this.$refs.LinkQR035.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.printContent td,
th {
  text-align: center;
  position: relative;
  border-color: #000;
  word-break: break-all;
  padding: 2px 6px;
  font-size: 12px;
  * {
    display: inline-block;
    max-height: 50px;
    overflow: hidden;
  }
}
.printContent {
  table {
    border-bottom: 0;
  }
  thead {
    background: #888;
    td{
      font-weight: 700;
    }
  }
  td {
    color: #000;
    font-weight: 400;
  }
}
</style>
